defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ClubSettings/Modals/ClubNameModal',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Ribbon',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton'
  ],
  function (m, PlayTogetherApi, Ribbon, CtaButton) {
    const ClubNameModal = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.clubNameMaxLength = this.clubModelFields().rules.clubNameMaxLength;
        this.loadingRandomName = m.prop(false);
        this.savingName = m.prop(false);

        this.temporaryClubName = m.prop(this.clubName()());
        this.getRandomName = () => {
          this.loadingRandomName(true);
          PlayTogetherApi.getRandomClubName()
            .then((response) => {
              this.temporaryClubName(response);
              this.loadingRandomName(false);
            })
            .catch((error) => {
              this.loadingRandomName(false);
              this.error(error);
            });
        };

        this.saveClubName = () => {
          this.savingName(true);
          const clubData = { ...this.clubModel().toJSON(), clubName: this.temporaryClubName() };

          PlayTogetherApi.updateClub(this.clubId(), clubData)
            .then((response) => {
              this.savingName(false);
              this.clubModelFields().clubName(response.name);
              this.modal.close();
            })
            .catch((error) => {
              this.savingName(false);
              this.error(error);
            });
        };
      },
      view: function (controller, { template }) {
        const remainingCharacters = controller.clubNameMaxLength - controller.temporaryClubName().length;
        const body = () => {
          return [
            Ribbon({
              asInput: true,
              title: controller.temporaryClubName
            }),
            remainingCharacters >= 0 ?
              m('.play-together-club-name-rule', controller.dictionary('EditClubNameOverlay/NameLengthDescription', { count: remainingCharacters })) :
              m('.play-together-club-name-rule', m('.play-together-error-text', controller.dictionary('EditClubNameOverlay/LengthNameExceeded'))
              ),
          ];
        };
        const footer = [
          CtaButton({
            onClick: controller.getRandomName,
            text: controller.dictionary('EditClubNameOverlay/RandomName'),
            icon: 'random',
            loading: controller.loadingRandomName()
          }),
          CtaButton({
            onClick: controller.saveClubName,
            text: controller.dictionary('EditClubNameOverlay/Confirm'),
            className: 'yellow',
            loading: controller.savingName()
          })
        ];

        return template({
          heading: controller.dictionary('EditClubNameOverlay/Title'),
          subheading: controller.dictionary('EditClubNameOverlay/Description'),
          body: body(),
          footer
        });
      }
    };

    // Public functions:
    return ClubNameModal;
  });
